/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Typography,
  Grid,
  Divider,
  TextField,
  IconButton
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';

import { LoadingButton } from '@mui/lab';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Password } from 'primereact/password';
import VerificationInput from 'react-verification-input';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  ContainerFormProfile,
  ErrorText,
  ContainerForm
} from '../CreateUser/createUserStyles';
import Strings from '../../../i18n';
import { colors } from '../../../constants/colors';
import { ContainerImage } from '../../../views/registration/registrationViewStyles';
import {
  useLoginWithOTPMutation,
  useLoginWithPasswordMutation,
  useStartLoginWithOTPMutation
} from '../../../services/auth/authServices';
import {
  loginWithOtpValidator,
  loginWithPasswordValidator
} from '../../../utils/validators';
import {
  selectCurrentUser,
  setCredentials,
  setRoleLoggedUser,
  setUserInfo
} from '../../../store/slices/login/login';
import { useGetLoggedUserSystemRolePermissionsMutation } from '../../../services/systemPermissions/systemPermissionsService';
import { useGetUserInfoMutation } from '../../../services/users/usersService';
import './loginWithPasswordStyle.css';
import { tokenUserIdEnum } from '../../../constants/commonEnums';

const logoImg = require('../../../assets/logo.png');

export const LoginWithPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginWithRedirect } = useAuth0();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const emailFromUrl = queryParams.get('email');
  const currentUser = useSelector(selectCurrentUser);
  const [passwordLess, setPasswordLess] = useState<boolean>(false);
  const [passwordLessType, setPasswordLessType] = useState<boolean | null>(
    null
  );
  const [emailError, setEmailError] = useState<string>('');
  const [
    loginWithPassword,
    { isSuccess: isSuccessLogin, isLoading, data, error, isError }
  ] = useLoginWithPasswordMutation();

  const [
    getRoleByToken,
    { isLoading: isLoadingGetRole, data: dataRole, isSuccess: isSuccessGetRole }
  ] = useGetLoggedUserSystemRolePermissionsMutation();

  const [
    sendOTPCode,
    {
      isSuccess: isSuccessSendingCode,
      error: errorSendOtp,
      isError: isErrorSendOtp
    }
  ] = useStartLoginWithOTPMutation();

  const [
    loginWithOTP,
    {
      isSuccess: isSuccessLoginWithOTP,
      data: dataLoginWithOTP,
      error: errorLoginWithOtp,
      isError: isErrorLoginWithOtp
    }
  ] = useLoginWithOTPMutation();

  const [
    getInfo,
    {
      isLoading: isLoadingGetInfo,
      data: dataGetInfo,
      isSuccess: isSuccessGetInfo,
      isError: isErrorGetInfo
    }
  ] = useGetUserInfoMutation();

  const sendInfo = (payload: any) => {
    loginWithPassword(payload);
  };

  const redirectToCreate = () => {
    navigate('/create-user');
  };

  const redirectToForgotPassword = () => {
    navigate('/reset-password');
  };

  useEffect(() => {
    if (isError && error) {
      toast.error(error.toString());
    }
  }, [isSuccessLogin, isError, error]);

  useEffect(() => {
    if (isErrorSendOtp && errorSendOtp) {
      if ('data' in errorSendOtp && errorSendOtp.data) {
        const errorData = errorSendOtp.data as { message?: string };
        toast.error(errorData.message || 'Error sending Code');
      } else {
        toast.error('Error sending Code');
      }
    }
  }, [isErrorSendOtp, errorSendOtp]);

  useEffect(() => {
    if (isErrorLoginWithOtp && errorLoginWithOtp) {
      if ('data' in errorLoginWithOtp && errorLoginWithOtp.data) {
        const errorData = errorLoginWithOtp.data as { message?: string };
        toast.error(errorData.message);
      } else {
        toast.error('Try again later.');
      }
    }
  }, [isErrorLoginWithOtp, errorLoginWithOtp]);

  useEffect(() => {
    if (isSuccessLogin && data) {
      toast.success(Strings.users.loginSuccess);
      dispatch(
        setCredentials({
          user: '',
          email: data.username,
          token: data.token,
          picture: '',
          roleInfo: '',
          userInfo: null,
          refreshToken: data.refreshToken,
          authWithApi: true,
          userId: data.id
        })
      );
      getRoleByToken('');
      if (
        data.id === tokenUserIdEnum.unauthorized ||
        data.id === tokenUserIdEnum.notFound
      ) {
        toast.error(
          data.id === tokenUserIdEnum.unauthorized
            ? Strings.users.userUnauthorized
            : Strings.users.userNotFound
        );
      } else {
        getInfo(data.id.toString());
      }
    }
  }, [isSuccessLogin && data]);

  useEffect(() => {
    if (isSuccessLoginWithOTP && dataLoginWithOTP) {
      toast.success(Strings.users.loginSuccess);
      dispatch(
        setCredentials({
          user: '',
          email: dataLoginWithOTP.username,
          token: dataLoginWithOTP.token,
          picture: '',
          roleInfo: '',
          userInfo: null,
          refreshToken: dataLoginWithOTP.refreshToken,
          authWithApi: true,
          userId: dataLoginWithOTP.id
        })
      );
      getRoleByToken('');
      if (
        dataLoginWithOTP.id === tokenUserIdEnum.unauthorized ||
        dataLoginWithOTP.id === tokenUserIdEnum.notFound
      ) {
        toast.error(
          dataLoginWithOTP.id === tokenUserIdEnum.unauthorized
            ? Strings.users.userUnauthorized
            : Strings.users.userNotFound
        );
      } else {
        getInfo(dataLoginWithOTP.id.toString());
      }
    }
  }, [isSuccessLoginWithOTP && dataLoginWithOTP]);

  useEffect(() => {
    if (dataGetInfo && isSuccessGetRole && isSuccessGetInfo) {
      const { firstName, lastName, phoneNumber, lastLogin } = dataGetInfo;
      dispatch(
        setRoleLoggedUser({
          roleInfo: dataRole
        })
      );
      dispatch(
        setUserInfo({
          userInfo: { firstName, lastName, phoneNumber, lastLogin }
        })
      );
      if (dataGetInfo.id > 0) {
        navigate('/');
      } else {
        toast.error('error');
      }
    }
    if (!isSuccessGetInfo && isErrorGetInfo) {
      toast.error('error');
    }
  }, [
    isLoadingGetInfo,
    isSuccessGetRole,
    data,
    isSuccessGetInfo,
    isErrorGetInfo
  ]);

  useEffect(() => {
    if (isSuccessSendingCode) {
      toast.success('Please check junk email folder.');
      setPasswordLess((tmpPasswordLess) => !tmpPasswordLess);
    }
  }, [isSuccessSendingCode]);
  return (
    <ContainerImage>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="left"
        alignItems="center"
      >
        <Grid item xs={0.5} md={2} />
        <Grid item xs={11} md={6} lg={3.5}>
          <ContainerForm container padding={3} justifyContent="center">
            <Grid item xs={11}>
              <Typography align="center" marginY={2} variant="h5">
                <img src={logoImg} alt="Haven Logo" width={200} />
              </Typography>
              <Typography
                align="center"
                marginY={3}
                variant="h6"
                fontWeight="bold"
                color={colors.strongGray}
                paddingTop={2}
              >
                {Strings.login.logIn}
              </Typography>
            </Grid>
            <ContainerFormProfile item xs={10} md={8} lg={12}>
              <Formik
                enableReinitialize
                validationSchema={
                  passwordLess
                    ? loginWithOtpValidator
                    : loginWithPasswordValidator
                }
                initialValues={{
                  userName: emailFromUrl || '',
                  password: '',
                  otp: ''
                }}
                onSubmit={(values) => {
                  if (passwordLess) {
                    loginWithOTP({
                      username: values.userName,
                      password: values.otp
                    });
                  } else {
                    sendInfo({
                      userName: values.userName,
                      password: values.password
                    });
                  }
                }}
              >
                {({
                  handleChange,
                  handleSubmit,
                  values,
                  isValid,
                  setFieldTouched,
                  errors,
                  touched,
                  setFieldValue
                }) => (
                  <Grid
                    direction="row"
                    container
                    spacing={2}
                    justifyContent="center"
                  >
                    <Grid item xs={12} md={10}>
                      <TextField
                        value={values.userName}
                        id="userName"
                        label={Strings.userProfile.emailLabel}
                        onBlur={() => setFieldTouched('userName')}
                        onChange={handleChange('userName')}
                        name="userName"
                        fullWidth
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                      {touched.userName && errors.userName && (
                        <ErrorText>{errors.userName}</ErrorText>
                      )}
                      {emailError && <ErrorText>{emailError}</ErrorText>}
                    </Grid>
                    <Grid item xs={12} md={10} className="password-container">
                      <span className="password-label">
                        {Strings.userProfile.passwordLabel}
                      </span>
                      {passwordLess ? (
                        <div className="verification-input-wrapper">
                          <VerificationInput
                            classNames={{
                              container: 'container',
                              character: 'character',
                              characterInactive: 'character--inactive',
                              characterSelected: 'character--selected',
                              characterFilled: 'character--filled'
                            }}
                            value={values.otp}
                            length={4}
                            onChange={handleChange('otp')}
                            autoFocus
                            inputProps={{
                              autoComplete: 'new-password',
                              autoCorrect: 'off',
                              autoCapitalize: 'none',
                              spellCheck: 'false'
                            }}
                          />
                          <IconButton
                            aria-label="clear verification code"
                            className="clear-button"
                            onClick={() => {
                              setFieldValue('password', '');
                            }}
                            size="small"
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                          {touched.otp && errors.otp && (
                            <ErrorText>{errors.otp}</ErrorText>
                          )}
                        </div>
                      ) : (
                        <>
                          <Password
                            value={values.password}
                            id="password"
                            onBlur={() => setFieldTouched('password')}
                            onChange={handleChange('password')}
                            name="password"
                            toggleMask
                            feedback={false}
                            type="password"
                            className="w-100"
                          />
                          {touched.password && errors.password && (
                            <ErrorText>{errors.password}</ErrorText>
                          )}
                        </>
                      )}
                    </Grid>
                    <Grid item xs={10} md={8} marginTop={1}>
                      <LoadingButton
                        color="info"
                        className="w-100"
                        disabled={!isValid}
                        onClick={() => handleSubmit()}
                        variant="contained"
                        size="large"
                        loading={isLoading}
                      >
                        {Strings.common.send}
                      </LoadingButton>
                    </Grid>
                    <Grid item xs={10} md={12}>
                      <button
                        type="button"
                        className="btn-action"
                        onClick={redirectToForgotPassword}
                      >
                        {Strings.login.forgotPasswordAsk}
                      </button>
                    </Grid>
                    <Grid item xs={10} md={12} marginTop={1}>
                      <button
                        type="button"
                        className="btn-action"
                        onClick={() => {
                          if (!passwordLess && !values.userName) {
                            setEmailError(Strings.formCommons.fieldRequired);
                            return;
                          }
                          if (!passwordLess) {
                            sendOTPCode({
                              userInfo: values.userName,
                              targetType: 'Email'
                            });
                            setPasswordLessType(true);
                          }
                          if (passwordLess) {
                            setPasswordLess(false);
                          }
                        }}
                      >
                        {Strings.login.loginWith}{' '}
                        <span>
                          {passwordLess
                            ? Strings.login.password
                            : Strings.login.passwordless}
                          .
                        </span>
                      </button>
                    </Grid>
                    {!passwordLess && (
                      <Grid item xs={10} md={12} marginTop={1}>
                        <button
                          type="button"
                          className="btn-action"
                          onClick={() => {
                            if (!passwordLess && !values.userName) {
                              setEmailError(Strings.formCommons.fieldRequired);
                              return;
                            }
                            if (!passwordLess) {
                              sendOTPCode({
                                userInfo: values.userName,
                                targetType: 'SMS'
                              });
                              setPasswordLessType(false);
                            }
                            if (passwordLess) {
                              setPasswordLess(false);
                            }
                          }}
                        >
                          {Strings.login.loginWith}{' '}
                          <span>{Strings.login.passwordlessSMS} .</span>
                        </button>
                      </Grid>
                    )}
                    <Grid item xs={10} md={12}>
                      <button
                        type="button"
                        className="btn-action"
                        onClick={redirectToCreate}
                      >
                        {Strings.login.noAccount}
                        <span> {Strings.login.createOne}</span>
                      </button>
                    </Grid>
                  </Grid>
                )}
              </Formik>
            </ContainerFormProfile>
          </ContainerForm>
        </Grid>
        <ToastContainer
          newestOnTop
          position="bottom-center"
          draggable
          theme="colored"
          autoClose={4000}
        />
        <Divider variant="fullWidth" />
      </Grid>
    </ContainerImage>
  );
};
